// Translation: Terms of service > Landing > Form (Russian)
export default Object.freeze({})
